// TIP-609 — the two blocking banners, exactly as drawn. They sit below the
// allowance card, not inside it.
//
//   amber → the weekly allowance is spent, the monthly one is not
//   coral → the monthly allowance is spent
//
// A bought balance above zero clears both; that decision lives in
// deriveAllowance(), so this component only renders what it is handed.
//
// TIP-609 fix: the coral banner's membership half and its Become a Member
// button are suppressed for a Member, who already holds all three benefits it
// sells (inconsistencies 1 and 2).
import React from "react";
import "./counterpartyBriefs.css";
import { ReactComponent as WarningIcon } from "../../../../assets/icons/Warning.svg";
import CbButton from "./CbButton";
import { BANNER_COPY, ENTITLEMENTS } from "./briefsFixtures";

const BlockingBanner = ({ banner, allowance, onBuy, onBecomeMember }) => {
  if (!banner) return null;

  const isMonthly = banner.tone === "coral";
  const copy = isMonthly ? BANNER_COPY.coral : BANNER_COPY.amber;

  const heading = isMonthly ? copy.heading : copy.heading(allowance.week.cap);
  const body = isMonthly
    ? copy.body({
        resetDate: allowance.resetDate,
        unitLabel: allowance.tier.unitLabel,
        // Always the Member price: what membership would cost the reader, not
        // what they pay today. TIP-609: sent by the allowance endpoint as
        // pricing.member_unit; ENTITLEMENTS is the fixture path's answer.
        memberUnit: allowance.memberUnit ?? ENTITLEMENTS.member.unit,
        showMembershipPitch: banner.showMembershipPitch,
      })
    : copy.body({
        remaining: allowance.month.remaining,
        weekResetDate: allowance.weekResetDate,
        unitLabel: allowance.tier.unitLabel,
      });

  return (
    <div role="status" data-testid={`cb-banner-${banner.tone}`} className={`cb-banner cb-banner--${banner.tone}`}>
      <WarningIcon aria-hidden="true" className="cb-banner-icon" />
      <div>
        <div className="cb-banner-heading">{heading}</div>
        <div className="cb-banner-body">{body}</div>
        <div className="cb-banner-actions">
          <CbButton size="sm" onClick={onBuy}>{copy.primary}</CbButton>
          {banner.showMembershipPitch && (
            <CbButton
              size="sm"
              variant="secondary"
              tone={isMonthly ? "on-coral" : "on-amber"}
              onClick={onBecomeMember}
            >
              {BANNER_COPY.secondary}
            </CbButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlockingBanner;
